package com.wintermar.inspection.core.ui.component.input.util

enum class InputType {
    TEXT,
    PASSWORD
}
